import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroller'
import { WHITE } from '../../theme/colors'
import DragScrollContainer from '../DragScrollContainer'

interface DivProps {
  fromYotpo?: boolean
  fromStore?: boolean
  sizeRecChecked?: boolean
  isBeingCompared?: boolean
}

export const Container = styled.div<{$storeFront?: boolean}>`
  ${props => props.$storeFront ? `
    @media (max-width: 698px) {
      position: relative;
    }
  ` : ''}
`

export const Content = styled.div`
  ${({ fromYotpo }: DivProps) => !fromYotpo ? `
    height: 70vh;
    overflow: auto;
  ` : ''};
  ${({ fromStore }: DivProps) => fromStore ? `
    height: fit-content;
    overflow: unset;
  ` : ''}
`

export const Text = styled.div`
  color: #5f6062;
  &:hover {
    cursor: pointer;
  }
`

interface HeadRowProps {
  withoutPadding?: boolean
  fromYotpo?: boolean
}

export const HeadRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ withoutPadding }: HeadRowProps) => withoutPadding ? '32px' : '15px'};
  padding: ${({ withoutPadding }: HeadRowProps) => withoutPadding ? '0' : '0 2% 0 5%'};
  @media (min-width: 320px) and (max-width: 480px) {
    padding: 0;
  }
`

export const TotalItems = styled.div`
  color: var(--color-neutral-secondary);
  font: 400 14px/22px var(--font-inter);
  @media (min-width: 320px) and (max-width: 748px) {
    text-align: center;
    position: absolute;
    top: -124px;
    right: 12px;
    font-size: 12px;
    ${({ fromStore }: DivProps) => fromStore ? `
      top: -30px;
      right: unset;
      left: 18px;
    ` : ''}
  }
`

export const SortOptions = styled.div`
  display: flex;
  align-items: center;
`
export const SortByLabel = styled.div`
  height: 22px;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-right: 5px;
`
export const StyledImg = styled.img`
  margin-left: 5px !important;
`

export const ThumbnailsList = styled.ul`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: auto;
  width: 100%;
  justify-content: center;
  padding: 0;
  gap: var(--spacing-32) var(--spacing-20);
  background: var(--neutral-fill-lightest);
  margin-left: ${({ withoutPadding }: HeadRowProps) => withoutPadding ? '-54px' : '0'};
`

export const DraggableList = styled(DragScrollContainer)`
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 0;
  background: ${WHITE};
  margin-left: ${({ withoutPadding }: HeadRowProps) => withoutPadding ? '-54px' : '0'};
  margin-bottom: 0;
  column-gap: var(--spacing-16);
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 100%;
  overflow-x: scroll;
  width: auto;
`
  
export const ThumbnailListItem = styled.li`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;
  min-width: 228px;
  ${({ fromYotpo }: DivProps) => fromYotpo ? `
    max-width: 240px;
  ` : ''}
  padding-bottom: ${({ fromStore }: DivProps) => fromStore ? '2px' : '20px'};
  align-items: center;
  justify-content: center;
  border: ${({ sizeRecChecked }: DivProps) => sizeRecChecked ? '1px solid #6d07f4' : 'unset'};
  background: ${WHITE};
  margin: 18px 16px;
  border-radius: 3px;
  transition: all .25s;
  box-shadow: ${({ isBeingCompared }: DivProps) => isBeingCompared ? 
    '0px 0px 8px 1px #00aaff' : '0px 2px 10px -4px #b1b1b1;'};
  @media (min-width: 481px) and (max-width: 1024px) {
    margin: 12px 6px;
  }

  @media (min-width: 320px) and (max-width: 714px) {
    margin: 0;
    min-width: unset;
    width: ${({ fromYotpo }: DivProps) => fromYotpo ? 'calc(100% / 2)' : '100%'};
    margin-bottom: 17px;
    ${({ fromYotpo }: DivProps) => fromYotpo ? `
      margin-left: 22px;
      width: auto;
      margin-left: unset;
    ` : ''}
  }
  /* TODO: V2 Replace and clean */
  &[data-isv2="true"] {
    max-width: 308px;
    width: calc((100% - 60px) / 4);
    min-width: 268px;
    margin: 0;
    box-shadow: unset;
    border: unset;
    padding: 0;
    ${({ fromYotpo }: DivProps) => fromYotpo ? `
      max-width: unset;
      width: 324px;
      min-width: 324px;
    ` : ''}
    @media (max-width: 767px) {
      max-width: 100%;
      width: 100%;
    }
  }
`

export const Loading = styled.div`
  display: flex;
  height: 12px;
  justify-content: center;
  align-items: center;
`
export const PaginationRow = styled.div`
  text-align: right;
  padding-right: 2%;

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 0;
    text-align: center;
  }
`

export const MenuStyle = {
  width: '200px'
}

export const NoResultsFound = styled.div`
  display: flex;
  height: 60vh;
  justify-content: center;
`

export const InfiniteScrollStyled = styled(InfiniteScroll)`
  height: 100%;
  ${({ fromYotpo }: DivProps) => fromYotpo ? `
    display: flex;
    justify-content: center;
  ` : ''}
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignsCatalogueThumbnailList/styledComponents.tsx